import StormBuildUpTable, { StormBuildUpTableProps } from "./StormBuildUpTable";
import { HEADWALL_ROWS } from "../../../utils/stormBuildUpHeadwalls";

type HeadwallsTableProps = Omit<StormBuildUpTableProps, 'rows'>;

export default function HeadwallsTable(props: HeadwallsTableProps) {
  return <StormBuildUpTable rows={HEADWALL_ROWS} {...props} />;
}
